export default "__VITE_ASSET__DknBObiU__"